import { useEffect, useState } from "react";
import { useGetRevenueEachStoreApi } from "../../hooks";
import {
  useAccountStore,
  useRevenueEachStore,
  useRevenueOverall,
} from "../../store";
import { formatToVND, getStartEndOfAnyMonth } from "../../helper";
import {
  Bar,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Line,
  ComposedChart,
} from "recharts";
import LoadingItem from "../common/LoadingItem";

const DashBoardChartTopLeft = () => {
  const { setEndDate, setStartDate, monthSelect, setMonthSelect } =
    useRevenueEachStore();

  const {
    endDate,
    startDate,
    setAccountId,
    monthSelect: monthSelectMain,
  } = useRevenueOverall();

  // state
  const [revenueData, setRevenueData] = useState<any>();
  const { info } = useAccountStore();

  const currentDate = new Date();
  const monthCurrent = currentDate.getMonth() + 1;
  const yearCurrent = currentDate.getFullYear();

  const { isLoading, revenueEachStore } = useGetRevenueEachStoreApi();

  const { end: endDayOfMonth, start: startDayOfMonth } = getStartEndOfAnyMonth(
    yearCurrent,
    monthSelect ? monthSelect - 1 : monthCurrent - 1
  );

  useEffect(() => {
    if (info?.role && info?.role === "ROLE_ADMIN") {
      setAccountId(undefined);
    } else if (info?.role && info?.role === "ROLE_INVERTOR") {
      setAccountId(info?.id);
    }
    if (!monthSelect) {
      setMonthSelect(monthCurrent - 2);
    }
    setEndDate(endDayOfMonth);
    setStartDate(startDayOfMonth);
    if (revenueEachStore?.data && revenueEachStore?.code === 200) {
      setRevenueData(revenueEachStore?.data);
    }
  }, [info?.role, monthSelect, isLoading, endDate, startDate, monthSelectMain]);

  const formatLabel = (value: any) => {
    return formatToVND(value);
  };

  return (
    <div className="flex-col w-full h-[100%] overflow-y-auto flex justify-center items-center">
      {isLoading ? (
        <LoadingItem isLoading={isLoading} title={"Loading"}></LoadingItem>
      ) : (
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={revenueData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis style={{ fontSize: 9 }} dataKey="storeCode" />
            <YAxis
              tickFormatter={formatLabel}
              style={{ fontSize: 9 }}
              dataKey="revenue"
            />
            <Tooltip
              formatter={(value: number, name) => {
                if (name === "revenue") {
                  return formatToVND(value); // Hiển thị cho Bar
                }
                return null; // Không hiển thị cho Line
              }}
            />

            <Legend />

            <Bar
              className="max-md:hidden"
              dataKey="revenue"
              fill="#1dc75a"
              barSize={22}
            />

            <Line
              className="max-md:hidden"
              tooltipType="none"
              dataKey="revenue"
              stroke="#070302"
              fill="#070302"
              type="monotone"
              strokeWidth={2}
              legendType="none"
            />

            <Line
              className="md:hidden"
              tooltipType="none"
              dataKey="revenue"
              stroke="#1dc75a"
              fill="#1dc75a"
              type="monotone"
              strokeWidth={2}
              legendType="none"
            />
          </ComposedChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default DashBoardChartTopLeft;
